import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex-ter"
}
const _hoisted_2 = { class: "flex-end" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  style: {"height":"20px","margin-right":"4px"},
  src: "https://static-jp.theckb.com/static-asset/choice/manual/tiktok_logo.png",
  alt: ""
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { style: {"font-weight":"600","font-size":"14px"} }, "TikTokの操作ガイドを見る", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("img", {
  style: {"height":"18px"},
  src: "https://static-jp.theckb.com/static-asset/choice/manual/arrow-left.png",
  alt: ""
}, null, -1)
const _hoisted_6 = [
  _hoisted_3,
  _hoisted_4,
  _hoisted_5
]
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "close-btn" }

import { ShopType } from '@/common/const';
import { computed, ref, useAttrs } from 'vue'
import { useStore } from 'vuex';

export default /*#__PURE__*/_defineComponent({
  props: {
    src: { type: String, required: true }
  },
  setup(__props: any) {

const props = __props as { src: string }


const attrs = useAttrs()

const visible = ref(false)

const store = useStore()

const isTikTokShop = computed(() => attrs.show !== undefined ? attrs.show : store.getters.shopInfo?.customerShopPlatform === ShopType.TIKTOK)


return (_ctx: any,_cache: any) => {
  const _component_ElDialog = _resolveComponent("ElDialog")!

  return (_unref(isTikTokShop))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _renderSlot(_ctx.$slots, "default", {}, () => [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", {
              class: "flex-center cursor-pt",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (visible.value = true))
            }, _hoisted_6)
          ])
        ]),
        _createVNode(_component_ElDialog, _mergeProps({
          "modal-class": "manual-modal",
          "append-to-body": "",
          modelValue: visible.value,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((visible).value = $event)),
          "close-on-click-modal": false,
          "destroy-on-close": true,
          onClosed: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('destory'))),
          top: "10vh"
        }, _ctx.$attrs, { width: 1080 }), {
          default: _withCtx(() => [
            _createElementVNode("iframe", {
              src: '/hub/manual/' + __props.src,
              frameborder: "0"
            }, null, 8, _hoisted_7),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("img", {
                onClick: _cache[1] || (_cache[1] = ($event: any) => (visible.value = false)),
                src: "https://static-jp.theckb.com/static-asset/choice/live_preview_banner/close-icon.png",
                alt: ""
              })
            ])
          ]),
          _: 1
        }, 16, ["modelValue"])
      ]))
    : _createCommentVNode("", true)
}
}

})